var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62675",
    "data-name": "Group 62675",
    transform: "translate(-86 -428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16382",
    "data-name": "Rectangle 16382",
    transform: "translate(86 428)",
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 25.3,
    rx: 1.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Call_us",
    "data-name": "Call us",
    transform: "translate(286 443)",
    fill: "#3e3e3e",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Call us")), /*#__PURE__*/React.createElement("text", {
    id: "Schedule_Appointment",
    "data-name": "Schedule Appointment",
    transform: "translate(271 443)",
    fill: "#3e3e3e",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -55.066,
    y: 0
  }, "Schedule Appointment")), /*#__PURE__*/React.createElement("text", {
    id: "Legal_Counsel_Appointment",
    "data-name": "Legal Counsel Appointment",
    transform: "translate(95 443)",
    fontSize: 6,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Legal Counsel Appointment")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader4);
export default __webpack_public_path__ + "static/media/header4.1830f4b074302a3133ba040fc76c220b.svg";
export { ForwardRef as ReactComponent };